import { render } from "./EmailDetailPage.vue?vue&type=template&id=4d03f04e"
import script from "./EmailDetailPage.vue?vue&type=script&lang=js"
export * from "./EmailDetailPage.vue?vue&type=script&lang=js"

import "./EmailDetailPage.vue?vue&type=style&index=0&id=4d03f04e&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__